<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="89" height="89" viewBox="0 0 89 89">
  <defs>
    <path id="ukkwk79uka" d="M17.116 10.243c22.014 2.108 34.659 5.854 20.843 13.349-34.894 19.202 27.634 7.962 49.647 14.753.469.234.703.234 1.171.469C85.967 17.035 67.466.173 44.984.173c-10.538 0-20.374 3.747-27.868 10.07zM.958 44.2c0 14.753 7.26 27.868 18.5 35.83 41.684-15.691 63.464-29.976 48.008-36.065-22.95-9.132-79.155 0-44.963-19.438 13.582-7.727 7.026-10.772-7.027-13.113C6.578 19.611.958 31.32.958 44.2zm20.374 37.235c6.791 4.216 14.987 6.791 23.652 6.791 22.482 0 41.217-16.862 43.793-38.64-8.899 9.133-33.489 21.545-67.445 31.849z"/>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <g>
      <g transform="translate(-140 -208) translate(140 208)">
        <mask id="cuas4xzk3b" fill="#fff">
          <use xlink:href="#ukkwk79uka"/>
        </mask>
        <path fill="#2490FF" d="M-3.275 92.46L93.01 92.46 93.01 -4.06 -3.275 -4.06z" mask="url(#cuas4xzk3b)"/>
      </g>
    </g>
  </g>
</svg>
